import React from 'react';

import type { SVGProps } from 'react';

export const SearchMessagesIcon: React.FC<SVGProps<SVGSVGElement>> = (
  props,
) => (
  <svg
    width="79"
    height="79"
    viewBox="0 0 79 79"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M57.9769 51.0729C61.8813 45.7573 64.1875 39.1948 64.1875 32.0938C64.1875 14.3689 49.8186 0 32.0938 0C14.3689 0 0 14.3689 0 32.0938C0 49.8186 14.3689 64.1875 32.0938 64.1875C39.1968 64.1875 45.7608 61.88 51.0772 57.9738L51.0729 57.9769C51.2186 58.1744 51.3808 58.3634 51.5595 58.5422L70.5712 77.5539C72.4994 79.4821 75.6256 79.4821 77.5539 77.5539C79.4821 75.6256 79.4821 72.4994 77.5539 70.5712L58.5422 51.5595C58.3634 51.3808 58.1744 51.2186 57.9769 51.0729ZM59.25 32.0938C59.25 47.0917 47.0917 59.25 32.0938 59.25C17.0958 59.25 4.9375 47.0917 4.9375 32.0938C4.9375 17.0958 17.0958 4.9375 32.0938 4.9375C47.0917 4.9375 59.25 17.0958 59.25 32.0938Z"
      fill="currentColor"
    />
    <path
      d="M17.5 25.4016C17.5 23.4129 19.1122 21.8008 21.1009 21.8008H42.706C44.6947 21.8008 46.3068 23.4129 46.3068 25.4016V39.805C46.3068 41.7937 44.6947 43.4059 42.706 43.4059H21.1009C19.1122 43.4059 17.5 41.7937 17.5 39.805V25.4016ZM21.1009 23.6012C20.1065 23.6012 19.3004 24.4073 19.3004 25.4016V25.7922L31.9034 33.3539L44.5064 25.7922V25.4016C44.5064 24.4073 43.7003 23.6012 42.706 23.6012H21.1009ZM44.5064 27.8918L36.0298 32.9777L44.5064 38.1941V27.8918ZM44.4456 40.2707L34.2905 34.0213L31.9034 35.4536L29.5164 34.0213L19.3612 40.2707C19.5664 41.0393 20.2675 41.6055 21.1009 41.6055H42.706C43.5393 41.6055 44.2404 41.0393 44.4456 40.2707ZM19.3004 38.1941L27.777 32.9777L19.3004 27.8918V38.1941Z"
      fill="currentColor"
    />
  </svg>
);
